/**
 * お届け先情報を更新に関する処理
 */

var DeliveryAddress = DeliveryAddress || {};

/**
 * お届け先情報を更新する
 *
 * @param object params
 *
 * @return Deferred
 */
DeliveryAddress.modifyDeliveryAddress = function(params) {
	var defer = $.Deferred();
	$.ajax({
		url: '/service/modify-delivery-address',
		method: 'POST',
		data: params,
		success: defer.resolve,
		error: defer.reject
	});

	return defer;
};
